<template>
  <div class="content">
    <div class="title">调剂报告详情</div>
    <div>
      <el-radio-group v-model="dataType"
                      @input="dataTypeChange">
        <el-radio-button label="1">大数据推荐（意向)</el-radio-button>
        <!-- <el-radio-button label="2">大数据推荐（全国）</el-radio-button> -->
      </el-radio-group>
      <el-table class="table"
                :data="results"
                border
                style="width: 100%; margin-top: 18px"
                :span-method="objectSpanMethod">
        <el-table-column label="类别"
                         width="160"
                         align="center"
                         fixed>
          <template slot-scope="scope">
            {{
              scope.row.type == 0
                ? "保底院校"
                : scope.row.type == 1
                ? "重点推荐院校"
                : scope.row.type == 2
                ? "备选院校"
                : "冲刺院校"
            }}
          </template>
        </el-table-column>

        <el-table-column prop="province_name"
                         label="省份"
                         min-width="100"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.isViewMore"
                 style="color: #409EFF; cursor: pointer;"
                 @click="handleViewMore(scope.row)">
              {{ scope.row.viewMoreText }}
            </div>
            <div v-else>{{ scope.row.province_name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="college_name"
                         label="院校名称"
                         min-width="160"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.isViewMore"
                 style="color: #409EFF; cursor: pointer;"
                 @click="handleViewMore(scope.row)">
              {{ scope.row.viewMoreText }}
            </div>
            <div v-else>{{ scope.row.college_name }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="major_name"
                         label="专业名称"
                         min-width="160"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.isViewMore"
                 style="color: #409EFF; cursor: pointer;"
                 @click="handleViewMore(scope.row)">
              {{ scope.row.viewMoreText }}
            </div>
            <div v-else>{{ `${scope.row.major_name}(${scope.row.major_code})` }}</div>
          </template>
        </el-table-column>
        <el-table-column label="院校类型"
                         min-width="210"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.isViewMore"
                 style="color: #409EFF; cursor: pointer;"
                 @click="handleViewMore(scope.row)">
              {{ scope.row.viewMoreText }}
            </div>
            <div v-if="scope.row.college_category_level">
              <el-tag style="margin-right: 5px">
                {{ scope.row.college_category_level=='1'?'985' :scope.row.college_category_level=='2'?'211':scope.row.college_category_level=='3'?'双一流':scope.row.college_category_level=='4'?'双非':''}}
              </el-tag>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="院校调剂人数"
                         min-width="120"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.isViewMore"
                 style="color: #409EFF; cursor: pointer;"
                 @click="handleViewMore(scope.row)">
              {{ scope.row.viewMoreText }}
            </div>
            <div v-else>{{ scope.row.cm_user_count_all_pre || 0 }}人</div>
          </template>
        </el-table-column>
        <el-table-column label="25录取最低分"
                         min-width="120"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.isViewMore"
                 style="color: #409EFF; cursor: pointer;"
                 @click="handleViewMore(scope.row)">
              {{ scope.row.viewMoreText }}
            </div>
            <div v-else>{{ scope.row.cm_low_score_comb_pre || 0 }}分</div>
          </template>
        </el-table-column>
        <el-table-column label="26调剂公告"
                         min-width="120"
                         align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.isViewMore"
                 style="color: #409EFF; cursor: pointer;"
                 @click="handleViewMore(scope.row)">
              {{ scope.row.viewMoreText }}
            </div>
            <div v-else>{{ !scope.row.adjust_id_year_new?'未出' :'已出'}}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column label="2023年"
                         min-width="80"
                         align="center">
          <template slot-scope="scope">
            {{ formateList(scope.row.college_id_year_plan_counts, 2023) }}
          </template>
        </el-table-column>
        <el-table-column label="2022年"
                         min-width="80"
                         align="center">
          <template slot-scope="scope">
            {{ formateList(scope.row.college_id_year_plan_counts, 2022) }}
          </template>
        </el-table-column>
        <el-table-column label="2021年"
                         min-width="80"
                         align="center">
          <template slot-scope="scope">
            {{ formateList(scope.row.college_id_year_plan_counts, 2021) }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="操作"
                         width="100"
                         align="center"
                         fixed="right">
          <template slot-scope="scope">
            <div v-if="scope.row.isViewMore"
                 style="color: #409EFF; cursor: pointer;"
                 @click="handleViewMore(scope.row)">
              查看更多
            </div>
            <el-link type="primary"
                     :underline="false"
                     @click="handleDetail(scope.row)">详情</el-link>
          </template>
        </el-table-column> -->
        <el-table-column label="操作"
                         width="100"
                         align="center"
                         fixed="right">
          <template slot-scope="scope">
            <div v-if="scope.row.isViewMore"
                 style="color: #409EFF; cursor: pointer; text-align: center;"
                 @click="handleViewMore(scope.row)">
              查看更多
            </div>
            <el-link v-else
                     type="primary"
                     :underline="false"
                     @click="handleDetail(scope.row)">详情</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="makeFor"
         v-if="false">
      <div style="margin-right: 50px">
        <div class="tit">同校去向</div>
        <el-table class="table"
                  :data="adjust_target_dataList"
                  border
                  style="width: 400px; margin-top: 18px"
                  :span-method="objectSpanMethodSchool">
          <el-table-column label="调剂去向"
                           width="160"
                           align="center"
                           fixed>
            <template>
              一志愿本院校专业<br />的考生调剂到成功的<br />去向院校
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           label="院校名称"
                           align="center">
          </el-table-column>

          <el-table-column prop="college_name"
                           label="人数"
                           align="center">
            <template slot-scope="scope"> {{ scope.row.count }} 人 </template>
          </el-table-column>
        </el-table>
      </div>

      <div>
        <div class="tit">同分去向</div>
        <el-table class="table"
                  :data="same_score_dataList"
                  border
                  style="width: 400px; margin-top: 18px"
                  :span-method="objectSpanMethodSchoolSco">
          <el-table-column label="调剂去向"
                           width="160"
                           align="center"
                           fixed>
            <template>
              一志愿本院校专业<br />的考生调剂到成功的<br />去向院校
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           label="院校名称"
                           align="center">
          </el-table-column>

          <el-table-column prop="college_name"
                           label="人数"
                           align="center">
            <template slot-scope="scope"> {{ scope.row.count }} 人 </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 40px">
        <div class="tit">同校录取</div>
        <el-table class="table"
                  :data="recruit_percents_dataList"
                  border
                  style="width: 850px; margin-top: 18px">
          <el-table-column label="调剂至985院校"
                           align="center"
                           fixed>
            <template slot-scope="scope">
              {{ scope.row["985"] ? Number(scope.row["985"]) * 100 + "%" : 0 }}
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           label="调剂至211院校"
                           align="center">
            <template slot-scope="scope">
              {{ scope.row["211"] ? Number(scope.row["211"]) * 100 + "%" : 0 }}
            </template>
          </el-table-column>

          <el-table-column prop="college_name"
                           label="调剂至双非院校"
                           align="center">
            <template slot-scope="scope">
              {{
                scope.row["empty"] ? Number(scope.row["empty"]) * 100 + "%" : 0
              }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <MoreDataDialog ref="moreDataDialog"
                    :query-params="{ uid: uid }"
                    @detail="handleDetail"
                    @close="onMoreDataClose" />
    <ReportDetailDetail ref="reportDetailDetail" />
  </div>
</template>
<script>
import { recommendReport } from '@/api/common.js'
import { getProvincelist } from '@/api/adjust.js'
import ReportDetailDetail from '@/components/adjust/report/ReportDetailDetail.vue'
import MoreDataDialog from '@/components/adjust/report/MoreDataDialog.vue'
export default {
  components: {
    ReportDetailDetail,
    MoreDataDialog,
  },
  props: {
    uid: {
      default: null,
    },
    time: {
      default: null,
    },
    dataObj: {
      default: null,
    },
  },
  data() {
    return {
      dataType: 1,
      dataLength: [],
      results: [],
      category_ids: [
        {
          value: 1,
          label: '985',
        },
        {
          value: 2,
          label: '211',
        },
        {
          value: 3,
          label: '双一流',
        },
        {
          value: 4,
          label: '双非',
        },
        //   {
        //   value: 3,
        //   label: '一流大学',
        // },
        // {
        //   value: 4,
        //   label: '一流学科',
        // },
        // {
        //   value: 5,
        //   label: '自主划线',
        // },
        // {
        //   value: 6,
        //   label: '研究所',
        // },
      ],
      adjust_target_dataList: [],
      same_score_dataList: [],
      recruit_percents_dataList: [],
      provincelist: [],
      adjustreportid: '',
    }
  },

  watch: {
    time: {
      handler(val) {
        this.getRecommendReport()
        this.fetchProvincelist()
      },
      immediate: true,
    },
  },
  methods: {
    handleViewMore(row) {
      let categoryValue = null

      switch (row.viewMoreCategory) {
        case 'bottom':
          categoryValue = 3
          break
        case 'emphasis':
          categoryValue = 1
          break
        case 'spare':
          categoryValue = 4
          break
        case 'sprint':
          categoryValue = 2
          break
      }

      // 打开弹窗，传入类别和对应的值
      this.$refs.moreDataDialog.open(
        row.type,
        categoryValue,
        this.adjustreportid
      )
    },
    onMoreDataClose() {
      console.log('更多数据弹窗关闭')
    },
    fetchProvincelist() {
      getProvincelist().then((res) => {
        this.provincelist = res.list
      })
    },
    handleDetail(row) {
      this.$refs.reportDetailDetail.open(row, this.uid ? this.uid : 1)
    },
    getRecommendReport() {
      if (this.dataObj) {
        console.log('this.dataObj:', this.dataObj)
        this.getDataList(this.dataObj)
      } else {
        recommendReport({ uid: this.uid }).then((res) => {
          this.adjustreportid = res.id
          console.log()
          this.getDataList(res)
        })
      }
    },

    getDataList(res) {
      let arr_recommend_bottom_obj = null
      let arr_recommend_emphasis_obj = null
      let arr_recommend_spare_obj = null
      let arr_recommend_sprint_obj = null

      if (res.arr_recommend_bottom_obj) {
        arr_recommend_bottom_obj = res.arr_recommend_bottom_obj.map((item) => {
          const matchedProvince = this.provincelist.find(
            (province) => province.code === item.college_province_code
          )
          return {
            ...item,
            type: 0,
            province_name: matchedProvince ? matchedProvince.name : '',
          }
        })
      } else {
        arr_recommend_bottom_obj = []
      }
      if (res.arr_recommend_emphasis_obj) {
        arr_recommend_emphasis_obj = res.arr_recommend_emphasis_obj.map(
          (item) => {
            const matchedProvince = this.provincelist.find(
              (province) => province.code === item.college_province_code
            )
            return {
              ...item,
              type: 1,
              province_name: matchedProvince ? matchedProvince.name : '',
            }
          }
        )
      } else {
        arr_recommend_emphasis_obj = []
      }

      if (res.arr_recommend_spare_obj) {
        arr_recommend_spare_obj = res.arr_recommend_spare_obj.map((item) => {
          const matchedProvince = this.provincelist.find(
            (province) => province.code === item.college_province_code
          )
          return {
            ...item,
            type: 2,
            province_name: matchedProvince ? matchedProvince.name : '',
          }
        })
      } else {
        arr_recommend_spare_obj = []
      }
      if (res.arr_recommend_sprint_obj) {
        arr_recommend_sprint_obj = res.arr_recommend_sprint_obj.map((item) => {
          const matchedProvince = this.provincelist.find(
            (province) => province.code === item.college_province_code
          )
          return {
            ...item,
            type: 3,
            province_name: matchedProvince ? matchedProvince.name : '',
          }
        })
      } else {
        arr_recommend_sprint_obj = []
      }
      const viewMoreRow = {
        type: -1, // 使用-1标识查看更多行
        isViewMore: true,
        viewMoreText: '查看更多...',
        // 补充必要字段，避免模板渲染报错
        province_name: '',
        college_name: '',
        major_name: '',
        major_code: '',
        cm_user_count_all_pre: '',
        college_id_year_plan_counts: '',
        college_category_level: '',
      }
      // 处理每个类别的数据，如果超过10条则截断并添加"查看更多"
      let finalBottomList = [...arr_recommend_bottom_obj]
      let finalEmphasisList = [...arr_recommend_emphasis_obj]
      let finalSpareList = [...arr_recommend_spare_obj]
      let finalSprintList = [...arr_recommend_sprint_obj]
      if (!this.dataObj) {
        // 检查并处理保底院校
        if (res.recommend_bottom_college_count > 10) {
          finalBottomList = finalBottomList.slice(0, 10)
          finalBottomList.push({
            ...viewMoreRow,
            type: 0,
            viewMoreCategory: 'bottom',
          })
        }

        // 检查并处理重点推荐院校
        if (res.recommend_emphasis_college_count > 10) {
          finalEmphasisList = finalEmphasisList.slice(0, 10)
          finalEmphasisList.push({
            ...viewMoreRow,
            type: 1,
            viewMoreCategory: 'emphasis',
          })
        }

        // 检查并处理备选院校
        if (res.recommend_spare_college_count > 10) {
          finalSpareList = finalSpareList.slice(0, 10)
          finalSpareList.push({
            ...viewMoreRow,
            type: 2,
            viewMoreCategory: 'spare',
          })
        }

        // 检查并处理冲刺院校
        if (res.recommend_sprint_college_count > 10) {
          finalSprintList = finalSprintList.slice(0, 10)
          finalSprintList.push({
            ...viewMoreRow,
            type: 3,
            viewMoreCategory: 'sprint',
          })
        }
      }
      // 更新dataLength数组（需要加上可能添加的"查看更多"行）
      this.dataLength = [
        finalBottomList.length,
        finalEmphasisList.length,
        finalSpareList.length,
        finalSprintList.length,
      ]

      // 合并所有数据
      this.results = [
        ...finalBottomList,
        ...finalEmphasisList,
        ...finalSpareList,
        ...finalSprintList,
      ]
      // let arr_recommend_all_best_obj = null
      // let arr_recommend_all_hard_obj = null
      // let arr_recommend_all_easy_obj = null
      // let arr_recommend_all_other_obj = null

      // if (res.arr_recommend_all_best_obj) {
      //   arr_recommend_all_best_obj = res.arr_recommend_all_best_obj.map(
      //     (item) => {
      //       return {
      //         ...item,
      //         type: 0,
      //       }
      //     }
      //   )
      // } else {
      //   arr_recommend_all_best_obj = []
      // }

      // if (res.arr_recommend_all_hard_obj) {
      //   arr_recommend_all_hard_obj = res.arr_recommend_all_hard_obj.map(
      //     (item) => {
      //       return {
      //         ...item,
      //         type: 1,
      //       }
      //     }
      //   )
      // } else {
      //   arr_recommend_all_hard_obj = []
      // }

      // if (res.arr_recommend_all_easy_obj) {
      //   arr_recommend_all_easy_obj = res.arr_recommend_all_easy_obj.map(
      //     (item) => {
      //       return {
      //         ...item,
      //         type: 2,
      //       }
      //     }
      //   )
      // } else {
      //   arr_recommend_all_easy_obj = []
      // }

      // if (res.arr_recommend_all_other_obj) {
      //   arr_recommend_all_other_obj = res.arr_recommend_all_other_obj.map(
      //     (item) => {
      //       return {
      //         ...item,
      //         type: 3,
      //       }
      //     }
      //   )
      // } else {
      //   arr_recommend_all_other_obj = []
      // }

      // if (this.dataType == 1) {
      // this.dataLength = [
      //   arr_recommend_bottom_obj.length,
      //   arr_recommend_emphasis_obj.length,
      //   arr_recommend_spare_obj.length,
      //   arr_recommend_sprint_obj.length,
      // ]
      // this.results = [
      //   ...arr_recommend_bottom_obj,
      //   ...arr_recommend_emphasis_obj,
      //   ...arr_recommend_spare_obj,
      //   ...arr_recommend_sprint_obj,
      // ]

      // } else {
      //   this.dataLength = [
      //     arr_recommend_all_best_obj.length,
      //     arr_recommend_all_hard_obj.length,
      //     arr_recommend_all_easy_obj.length,
      //     arr_recommend_all_other_obj.length,
      //   ]
      //   this.results = [
      //     ...arr_recommend_all_best_obj,
      //     ...arr_recommend_all_hard_obj,
      //     ...arr_recommend_all_easy_obj,
      //     ...arr_recommend_all_other_obj,
      //   ]
      // }

      // 同校去向
      if (res.college_major_adjust_target) {
        let arr = res.college_major_adjust_target.split(',')
        this.adjust_target_dataList = arr.map((v) => {
          return {
            count: v.match(/\d+/g)[0],
            name: v.slice(0, v.indexOf(v.match(/\d+/g)[0])),
          }
        })
      } else {
        this.adjust_target_dataList = []
      }

      // 同分去向
      if (res.same_score_adjust_target_users) {
        let arr = res.same_score_adjust_target_users.split(',')
        this.same_score_dataList = arr.map((v) => {
          return {
            count: v.match(/\d+/g)[0],
            name: v.slice(0, v.indexOf(v.match(/\d+/g)[0])),
          }
        })
      } else {
        this.same_score_dataList = []
      }

      let obj = {}

      if (res.college_major_adjust_recruit_percents) {
        res.college_major_adjust_recruit_percents.split(',').forEach((item) => {
          obj[item.split('_')[0]] = item.split('_')[1]
        })
      }
      this.recruit_percents_dataList = [obj]
      //

      // console.log(
      //   "this.same_score_dataList:",
      //   this.same_score_dataList
      // );
      // console.log("res:", this.results);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 处理第一列（类别列）
      if (columnIndex === 0) {
        // 计算每个类别的起始索引
        const bottomStart = 0
        const emphasisStart = this.dataLength[0]
        const spareStart = this.dataLength[0] + this.dataLength[1]
        const sprintStart =
          this.dataLength[0] + this.dataLength[1] + this.dataLength[2]

        // 保底院校类别
        if (
          row.type == 0 &&
          rowIndex >= bottomStart &&
          rowIndex < emphasisStart
        ) {
          if (rowIndex === bottomStart) {
            return {
              rowspan: this.dataLength[0],
              colspan: 1,
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            }
          }
        }
        // 重点推荐院校类别
        else if (
          row.type == 1 &&
          rowIndex >= emphasisStart &&
          rowIndex < spareStart
        ) {
          if (rowIndex === emphasisStart) {
            return {
              rowspan: this.dataLength[1],
              colspan: 1,
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            }
          }
        }
        // 备选院校类别
        else if (
          row.type == 2 &&
          rowIndex >= spareStart &&
          rowIndex < sprintStart
        ) {
          if (rowIndex === spareStart) {
            return {
              rowspan: this.dataLength[2],
              colspan: 1,
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            }
          }
        }
        // 冲刺院校类别
        else if (row.type == 3 && rowIndex >= sprintStart) {
          if (rowIndex === sprintStart) {
            return {
              rowspan: this.dataLength[3],
              colspan: 1,
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            }
          }
        }
      }

      // 处理其他列（省份到操作列）- 合并显示"查看更多"
      if (row.isViewMore && columnIndex >= 1) {
        if (columnIndex === 1) {
          // 从第2列开始合并到最后一列
          const totalColumns = 11 // 根据你的实际列数调整：省份、院校名称、专业名称、院校类型、调剂人数、2024、2023、2022、2021、操作
          return {
            rowspan: 1,
            colspan: totalColumns - 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    // objectSpanMethod({ row, column, rowIndex, columnIndex }) {
    //   if (columnIndex === 0) {
    //     if (rowIndex == 0 && row.type == 0) {
    //       return {
    //         rowspan: this.dataLength[0],
    //         colspan: 1,
    //       }
    //     } else if (rowIndex == this.dataLength[0] && row.type == 1) {
    //       return {
    //         rowspan: this.dataLength[1],
    //         colspan: 1,
    //       }
    //     } else if (
    //       rowIndex == this.dataLength[0] + this.dataLength[1] &&
    //       row.type == 2
    //     ) {
    //       return {
    //         rowspan: this.dataLength[2],
    //         colspan: 1,
    //       }
    //     } else if (
    //       rowIndex ==
    //         this.dataLength[0] + this.dataLength[1] + this.dataLength[2] &&
    //       row.type == 3
    //     ) {
    //       return {
    //         rowspan: this.dataLength[3],
    //         colspan: 1,
    //       }
    //     } else {
    //       return {
    //         rowspan: 0,
    //         colspan: 0,
    //       }
    //     }
    //   }
    // },

    objectSpanMethodSchool({ row, column, rowIndex, columnIndex }) {
      // console.log("Xx",rowIndex, columnIndex)
      if (columnIndex === 0) {
        if (rowIndex == 0) {
          return {
            rowspan: this.adjust_target_dataList.length,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },

    objectSpanMethodSchoolSco({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex == 0) {
          return {
            rowspan: this.same_score_dataList.length,
            colspan: 1,
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          }
        }
      }
    },
    dataTypeChange(e) {
      this.dataType = e
      this.getRecommendReport()
      // console.log('e:', e)
    },
    formateList(list, year) {
      if (list) {
        let obj = list.split(',').find((item) => {
          return item.split('-')[1] == year
        })
        // console.log("obj",obj)
        if (obj) {
          return obj.split('-')[2]
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
  },
}
</script>


<style lang="less" scoped>
.content {
  width: 100%;
  font-family: PingFang SC, PingFang SC;
}

.title {
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 33px;
}
.makeFor {
  margin-top: 35px;
  display: flex;
  flex-wrap: wrap;
  font-family: PingFang SC, PingFang SC;
  .tit {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 18px;
  }
}
</style>
